// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"4d618aeb","796":"5018ae5c"}[chunkId] + ".chunk.js";
};